import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UseRadioGroup from './UseRadioGroup';
import ClientProvider from './client';
export default createDemo(import.meta.url, UseRadioGroup, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/radio-buttons/demos/use-radio-group/UseRadioGroup.tsx",
    "fileName": "UseRadioGroup.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport type { FormControlLabelProps } from '@mui/material/FormControlLabel';\nimport Radio from '@mui/material/Radio';\n\ninterface StyledFormControlLabelProps extends FormControlLabelProps {\n  checked: boolean;\n}\n\nconst StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (\n  <FormControlLabel {...props} />\n))(({ theme }) => ({\n  variants: [\n    {\n      props: { checked: true },\n      style: {\n        '.MuiFormControlLabel-label': {\n          color: theme.palette.primary.main,\n        },\n      },\n    },\n  ],\n}));\n\nfunction MyFormControlLabel(props: FormControlLabelProps) {\n  const radioGroup = useRadioGroup();\n\n  let checked = false;\n\n  if (radioGroup) {\n    checked = radioGroup.value === props.value;\n  }\n\n  return <StyledFormControlLabel checked={checked} {...props} />;\n}\n\nexport default function UseRadioGroup() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <RadioGroup name=\"use-radio-group\" defaultValue=\"first\">\n      <MyFormControlLabel value=\"first\" label=\"First\" control={<Radio />} />\n      <MyFormControlLabel value=\"second\" label=\"Second\" control={<Radio />} />\n    </RadioGroup>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 45,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport type { FormControlLabelProps } from '@mui/material/FormControlLabel';\nimport Radio from '@mui/material/Radio';\n\ninterface StyledFormControlLabelProps extends FormControlLabelProps {\n  checked: boolean;\n}\n\nconst StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (\n  <FormControlLabel {...props} />\n))(({ theme }) => ({\n  variants: [\n    {\n      props: { checked: true },\n      style: {\n        '.MuiFormControlLabel-label': {\n          color: theme.palette.primary.main,\n        },\n      },\n    },\n  ],\n}));\n\nfunction MyFormControlLabel(props: FormControlLabelProps) {\n  const radioGroup = useRadioGroup();\n\n  let checked = false;\n\n  if (radioGroup) {\n    checked = radioGroup.value === props.value;\n  }\n\n  return <StyledFormControlLabel checked={checked} {...props} />;\n}\n\nexport default function UseRadioGroup() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <RadioGroup name=\"use-radio-group\" defaultValue=\"first\">\n      <MyFormControlLabel value=\"first\" label=\"First\" control={<Radio />} />\n      <MyFormControlLabel value=\"second\" label=\"Second\" control={<Radio />} />\n    </RadioGroup>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "RadioGroup"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "name"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "use-radio-group",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "first",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyFormControlLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "first",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "First",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Radio"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyFormControlLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "second",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Second",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Radio"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "RadioGroup"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 45,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/RadioGroup",
      "@mui/material/FormControlLabel",
      "@mui/material/Radio"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
